export enum CustomerGroup {
    Todos = 1,
    PVC = 2,
    QUIMICOS = 3
}

export enum Country {
    Todos = `ALL`,
    Brasil = `BR`,
    Argentina = `AR`
}